import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { PlanChangeLink } from '../../utils/constant'
import TrialPlanChoice from '../trial/TrialPlanChoice'
import { useTrialDays } from '../referral/useTrialDays'
import { AppUseSelector } from '../../redux/hooks'

/**
 * /claim/free-trial — the "Start my 5-day free trial" button in story emails and on the email tap
 * page. Emails wrap it in a login link (/auth/e, PR #244), so a logged-out learner is signed in
 * first, then picks Standard or Pro here and goes straight to the checkout. `?plan=pro` shows the Pro
 * trial alone: the free Sunday email pitches Pro, so its button lands on Pro.
 */
const ClaimFreeTrial: React.FC = () => {
  const { t } = useTranslation('offers')
  const trialDays = useTrialDays()
  const proOnly = new URLSearchParams(useLocation().search).get('plan') === 'pro'
  // Same server rule as checkout (dev-backend src/common/trial-eligibility). Someone who has
  // already trialled would be charged at once, so they are sent to the plans instead.
  const trialEligibility = AppUseSelector(({ user }) => user.trialEligibility)
  if (trialEligibility && !trialEligibility.isEligible) {
    return (
      <div className='claim-free-trial'>
        <h1 className='claim-free-trial-title'>{t('claim.unavailableTitle')}</h1>
        <p className='claim-free-trial-sub'>{t('claim.unavailableBody')}</p>
        <a href={PlanChangeLink} className='claim-free-trial-browse'>
          {t('claim.seePlans')}
        </a>
      </div>
    )
  }
  return (
    <div className='claim-free-trial'>
      <h1 className='claim-free-trial-title'>{t(proOnly ? 'claim.titlePro' : 'claim.title', { days: trialDays })}</h1>
      <p className='claim-free-trial-sub'>
        {proOnly ? t('claim.proPitch') : t('claim.pickPlan')} {t('claim.cancelAnytime', { days: trialDays })}
      </p>
      <TrialPlanChoice only={proOnly ? 'pro' : undefined} />
      <a href={PlanChangeLink} className='claim-free-trial-browse'>
        {t('claim.compareAll')}
      </a>
    </div>
  )
}

export default ClaimFreeTrial
